import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { useIsMobileView } from "../../hooks/ui-hook";
import { IOS_APP_STORE_URL, LC_KEYS } from "../../utils/constants";
import { isIOS } from "../../utils/device.utils";

const IOSAppBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const isMobile = useIsMobileView();
  const { isMobilePath } = useAppSelector((state) => state.appState);

  useEffect(() => {
    const hideBanner = localStorage.getItem(LC_KEYS.HIDE_IOS_APP_BANNER);
    if (hideBanner === "true" || isMobilePath) {
      setShowBanner(false);
    } else if (isMobile && isIOS()) {
      setShowBanner(true);
    }
  }, [isMobile, isMobilePath]);

  const hideBanner = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(LC_KEYS.HIDE_IOS_APP_BANNER, "true");
    setShowBanner(false);
  };

  const openAppStore = () => {
    window.open(IOS_APP_STORE_URL, "_blank", "noopener,noreferrer");
  };

  if (!showBanner) return null;

  return (
    <div
      onClick={openAppStore}
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        color: "#fff",
        fontSize: 14,
        fontWeight: 500,
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
        cursor: "pointer",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
        <img
          src="/favicon.png"
          alt="Nudge AI"
          style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            background: "#fff",
            padding: 4,
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Get the Nudge AI App</span>
          <span style={{ fontSize: 12, opacity: 0.9 }}>Built for speed and reliability</span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span
          style={{
            background: "#fff",
            color: "#667eea",
            borderRadius: 6,
            padding: "8px 14px",
            fontWeight: 600,
            fontSize: 13,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          Open
        </span>
        <button
          onClick={hideBanner}
          aria-label="Close banner"
          style={{
            background: "rgba(255,255,255,0.2)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 28,
            height: 28,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <CloseOutlined style={{ fontSize: 12 }} />
        </button>
      </div>
    </div>
  );
};

export default IOSAppBanner;
